export const ANALYTICS_CHANGE_PERIODS = [ 'day', 'week', 'month', 'year', 'total' ] as const;

export type AnalyticsChangePeriod = typeof ANALYTICS_CHANGE_PERIODS[number];
